export const getDefaultSorting = key => {
  switch (key) {
    default:
      return {};
  }
};

const perPageDefaults = {
  ports_map: 100
};

export const getDefaultPageSize = key => {
  if (!key) return;

  return perPageDefaults?.[key];
};
